import { Controller } from '@hotwired/stimulus';

const REDIRECT_PATH = '/undistractor_settings';
// Prefix check rather than a domain list, so this holds on every host the app serves
const LITE_SUBDOMAIN_PREFIX = 'lite.';

export default class extends Controller {
  static values = {
    checkUrl: String,
  };

  async connect() {
    if (!this.checkUrlValue) return;

    const { hostname } = window.location;
    if (!hostname.startsWith(LITE_SUBDOMAIN_PREFIX)) return;

    const response = await fetch(this.checkUrlValue);
    if (!response.ok) return;

    const data = await response.json();
    if (!data.authenticated) return;

    const mainDomain = hostname.slice(LITE_SUBDOMAIN_PREFIX.length);
    const port = window.location.port ? `:${window.location.port}` : '';

    // replace() keeps the lite page out of history — otherwise back lands on lite, which
    // re-redirects forward, trapping the back button
    window.location.replace(`${window.location.protocol}//${mainDomain}${port}${REDIRECT_PATH}`);
  }
}
